import * as React from 'react';
import Page from '../containers/Page';
import TasksList  from '../containers/TasksList';
import { CATEGORY } from '../containers/TasksList/constants';

export default () => (
    <Page title="Waiting">
     <TasksList category={CATEGORY.WAITING} />
    </Page>
)